import { render, staticRenderFns } from "./FormControlLanguages.vue?vue&type=template&id=39475454&"
import script from "./FormControlLanguages.vue?vue&type=script&lang=js&"
export * from "./FormControlLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports